<script>
  import Navbar from "./Navbar.svelte";
  import { fade } from "svelte/transition";

  let files;
  let index = 0;
  let error = null;
  async function getBoys() {
    const req = await fetch("http://localhost:3000/api/ppl");
    const json = await req.json();
    files = json.files;
    return json.files;
  }
  function ok() {
    // open rarible url
  }
  function next() {
    index += 1;
    if (!files || index >= files.length - 1) {
      error = "All Matches!";
    }
  }
</script>

<div class="bg-blackSplash min-h-full mb-20">
  <Navbar />
  <!-- <button class="border-0 ph-2 m-1">
    <svg
      style="height:80px;shape-rendering:geometricPrecision;text-rendering:geometricPrecision;image-rendering:optimizeQuality;"
      viewBox="0 0 1846 4280"
      x="0px"
      y="0px"
      fill-rule="evenodd"
      clip-rule="evenodd"
    >
      <g>
        <path
          class="fil0"
          d="M1618 39c52,-52 136,-52 188,0 53,52 53,137 0,189l-1483 1484 1483 1484c53,52 53,137 0,189 -52,52 -136,52 -188,0l-1579 -1579c-52,-52 -52,-136 0,-188l1579 -1579z"
        />
      </g>
    </svg>
  </button> -->
  {#if error}
    <h1>!!! out of matches today</h1>
  {:else}
    <div class="flex w-50 justify-center content-center align-center flex-col">
      <div>
        <div transition:fade class="m-5 rounded-lg overflow-hidden">
          <video loop autoplay src="boys/boy1.mp4"
            ><track kind="captions" /></video
          >
        </div>
        <div>
          <dl class="font-arcade text-white text-2xl grid grid-cols-3 m-6">
            <dt>name:</dt>
            <dd class="col-span-2">carl</dd>
            <dt>pros:</dt>
            <dd class="col-span-2">loves his mother</dd>
            <dt>cons:</dt>
            <dd class="col-span-2">loves his mother</dd>
          </dl>
          <div class="flex text-white justify-around mt-6">
            <button
              class="border-0 font-arcade text-xl transition-opacity opacity-80 p-1 h-20 w-20 hover:opacity-100"
              on:click={next}
            >
              <img src="/img/no-sm.png" alt="No" />
              pass
            </button>
            <button
              class="font-arcade text-xl border-0 p-2 transition-opacity heart-animate h-20 opacity-80 hover:opacity-100 w-20"
              on:click={ok}
            >
              <img src="/img/yes-sm.png" alt="No" />
              smash
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- <button class="border-0 ph-2 m-1">
    <svg
      style="height:80px;transform:rotate(180deg);shape-rendering:geometricPrecision;text-rendering:geometricPrecision;image-rendering:optimizeQuality;"
      viewBox="0 0 1846 4280"
      x="0px"
      y="0px"
      fill-rule="evenodd"
      clip-rule="evenodd"
    >
      <g>
        <path
          class="fil0"
          d="M1618 39c52,-52 136,-52 188,0 53,52 53,137 0,189l-1483 1484 1483 1484c53,52 53,137 0,189 -52,52 -136,52 -188,0l-1579 -1579c-52,-52 -52,-136 0,-188l1579 -1579z"
        />
      </g>
    </svg>
  </button> -->
  {/if}
</div>

<style>
  @keyframes heart-rotate {
    10% {
      transform: rotateX(0) rotateY(0);
    }
    15% {
      transform: rotateX(-22deg) rotateY(22deg);
    }
    22% {
      transform: rotateX(0) rotateY(0);
    }
    77% {
      transform: rotateX(0) rotateY(0) scale(1);
    }
    82% {
      transform: rotateX(22deg) rotateY(12deg) scale(1.04);
    }
    87% {
      transform: rotateX(0) rotateY(0) scale(1);
    }
  }
  .heart-animate {
    animation: heart-rotate 2s infinite;
  }
</style>
